import * as React from 'react'
import { Spin, Form, Input } from 'antd'
import { isEmpty, get } from 'lodash'
import { showError } from 'helpers/errors'
import { renderBarcode } from 'helpers/listViews'
import { createLabelFactory } from 'helpers/formViews'
import { HARD_SPACE } from 'helpers/utils'
import { Header } from 'helpers/print'
import { formatUserTime } from 'helpers/dateTime'
import { getStatus } from 'helpers/pickList'
import { t } from 'helpers/i18n'
import DatePicker from 'elements/DatePicker'
import { Row, Col } from 'elements/Grid'
import PickListItems from 'containers/Requisitions/PickList/Items'

class Component extends React.Component {
  state = {}

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems = async () => {
    try {
      const responses = await Promise.all([
        this.props.getSettings({ type: this.props.settingsType }),
        this.props.getOnHandCounts(
          this.props.parentRecord.requisitionItems
            .filter((each) => this.props.selectedRowKeys.includes(each.id))
            .map((each, index) => ({ ...each, id: index + 1 }))
        ),
      ])

      this.setState({
        fieldSettings: responses[0].value.data.fieldSettings,
        pickListItems: responses[1].value.data,
      })
    } catch (error) {
      showError({ error })
    }
  }

  render() {
    const { parentRecord: item } = this.props
    const { fieldSettings = [] } = this.state
    const createLabel = createLabelFactory(item.fieldSettings)
    const { statusLanguageKey, statusClassName } = getStatus(item)

    if (isEmpty(fieldSettings)) {
      return <Spin />
    }

    return (
      <>
        <Header>
          <Row gutter={6}>
            <Col xs={8}>
              <Row>
                <Col xs={12}>
                  <Form.Item label={t('requisitionId')} colon={false}>
                    <Input value={item.id} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item label={HARD_SPACE}>
                    {renderBarcode({
                      displayFormat: item.fieldSettings.find((one) => one.dtoFieldName === 'idForImage')
                        .displayFormat,
                      value: item.id,
                      marginTop: 5,
                      marginBottom: 0,
                    })}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col xs={7}>
              <Form.Item label={t('created')} colon={false}>
                <Input value={formatUserTime(item.createDate, item.userName) || t('na')} readOnly />
              </Form.Item>
            </Col>
            <Col xs={9}>
              <Form.Item label={createLabel('statusName')} colon={false}>
                <Input
                  value={statusLanguageKey ? t(statusLanguageKey) : ''}
                  className={statusClassName}
                  readOnly
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col xs={15}>
              <Form.Item label={t('requisitionedBy')} colon={false}>
                <Input
                  value={['Name', 'Phone', 'Email']
                    .map((each) => get(item, `requisitioner${each}`))
                    .filter((each) => !isEmpty(each))
                    .join(', ')}
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col xs={9}>
              <Row>
                <Col xs={12}>
                  <Form.Item label={createLabel('requisitionNumber')} colon={false}>
                    <Input value={item.requisitionNumber} readOnly />
                  </Form.Item>
                </Col>
                <Col xs={12}>
                  <Form.Item label={createLabel('deliveryDueDate')} colon={false}>
                    <DatePicker value={item.deliveryDueDate} placeholder="" readOnly />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
        </Header>
        <PickListItems title={t('itemsTab')} settingsType="printPickList" items={this.state.pickListItems} />
      </>
    )
  }
}

export default Component
